export default __webpack_public_path__ + "static/media/title_pc.9a2bf5ad.png";